import React from "react";
import { IconButton, Tooltip, Divider, Button } from "@mzc-pdc/ui";
import { Typography } from "@mui/material";
import theme from "@styles/theme";

const TooltipButton = ({
    title,
    buttonText,
    hidden,
    disabled = false,
    onClickButton,
    buttonIcon,
    isEndIcon = false,
    isDivided = false,
    isResponsive = true,
    color = "inherit",
    size = "medium",
    sx,
    ...props
}) => {
    return (
        <>
            {!hidden && (
                <>
                    {isResponsive ? (
                        <Tooltip title={title}>
                            <IconButton
                                circled={props?.circled}
                                disabled={disabled}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClickButton();
                                }}
                                type="button"
                                variant={props?.variant ?? "text"}
                                size={size}
                                color={color}
                                sx={sx}
                            >
                                {buttonIcon}
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Button
                            {...(isEndIcon ? { endIcon: buttonIcon } : { startIcon: buttonIcon })}
                            disabled={disabled}
                            variant={props?.variant ?? "text"}
                            size={size}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickButton();
                            }}
                            color={color}
                            sx={sx}
                        >
                            {buttonText && <Typography variant={"body1_400"}>{buttonText}</Typography>}
                        </Button>
                    )}
                    {isDivided && <Divider flexItem orientation={"vertical"} sx={{ my: 0.5, opacity: 0.12 }} />}
                </>
            )}
        </>
    );
};

export default TooltipButton;
